import Vue from 'vue'
import App from './App.vue'
import route from './router'
import Antd, { Spin, Modal, message } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import animated from 'animate.css'
import fetch from './utils/fetch.js'
import moment from 'moment'
import 'moment/locale/zh-cn'
import echarts from 'echarts'
import { getUserInfo } from './views/Login.vue'

import shareState from './utils/shareState.js'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import store from './store'
import axios from 'axios'
import config from './api/httpConfig'
import http from './utils/request.js'
import loginHttp from './utils/loginHttp.js'

import Viewer from 'v-viewer'
// 图片预览
import 'viewerjs/dist/viewer.css'

import VueDraggableResizable from 'vue-draggable-resizable'

Vue.use(VideoPlayer)
Spin.setDefaultIndicator({
  indicator: (h) => {
    return '<a-icon type = "loading" / >'
  }
})
moment.locale('zh')
Vue.config.productionTip = false
Vue.use(elementUI)
Vue.use(Antd)
Vue.use(animated)
Vue.use(VueDraggableResizable)
const router = route({
  getUserInfo
})
message.config({
  top: '100px',
  duration: 2,
  maxCount: 3
})
Vue.prototype.$message = message
Vue.prototype.$echarts = echarts


Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.prototype.$axios = axios
Vue.prototype.$fetch = (request, onError = () => {}, afterResponse) => {
  const userInfo = getUserInfo()
  let classId = ''
  let bookId = request.body && request.body.bookId
  if (!bookId) {
    bookId =
      shareState.state.bookId || localStorage.getItem('syzg-bookId') || 1
  }
  if (
    userInfo &&
    userInfo.class &&
    userInfo.class.length &&
    userInfo.class[0].classId
  ) {
    classId = userInfo.class[0].classId
  }
  request.body = Object.assign({}, request.body, {
    access_token:
      (request.body && request.body.token) ||
      (userInfo && userInfo.access_token ? userInfo.access_token : localStorage.getItem('access_token')),
    userId:
      (request.body && request.body.userId) ||
      (userInfo && userInfo.id ? userInfo.id : localStorage.getItem('userId')),
    classId: (request.body && request.body.classId) || classId,
    bookId: (request.body && request.body.bookId) || bookId
  })

  return fetch(
    request,
    (err) => {
      if (err.response && err.response.status === 401) {
        router.currentRoute.name !== 'Login' &&
          router.push({
            name: 'Login'
          })
        Modal.destroyAll()
      } else onError(err)
    },
    (afterResponse) => {
      if (afterResponse.resultCode === 1200) {
        // message.info(afterResponse.resultMessage)
        router.push({
          name: 'MyBooks'
        })
      } else if (afterResponse.resultCode === '9') {
        // message.info(afterResponse.resultMessage)
        // router.push({
        //   name: 'Login',
        // });

        console.log('resultCode', 'resultCode==9')
        const vm = this
        vm.$confirm({
          title: '登录信息过期提示',
          content: '登录信息过期，请重新登录',
          cancelButtonProps: { style: { display: 'none' } },
          onOk () {
            window.localStorage.clear()
            sessionStorage.clear()
            localStorage.clear()
            // vm.$router.push({ name: 'Login' })
            console.log(process.env.NODE_ENV)
            window.location.replace(vm.$loginUrl)
          }
        })

        // if (process.env.NODE_ENV === 'production') {
        //   window.location.replace('https://www.e-snails.com/')
        // else  {
        //   window.location.replace('http://192.168.6.111:81/tea1/#/login')
        // }
      }
    }
  )
}
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    zIndex: 9999,
    inline: true, // 启用lnline模式
    button: true, // 显示右上角关闭按钮
    navbar: false, // 显示缩略图导航
    title: true, // 显示当前图片的标题
    toolbar: true, // 显示工具栏
    tooltip: true, // 显示缩放百分比
    movable: true, // 显示可移动
    zoomable: true, // 图片是否可缩放
    rotatable: true, // 图片是否可旋转
    scalable: true, // 图片是否可翻转
    transition: true, // 使用css3过度
    fullscreen: true, // 播放时是否全屏
    keyboard: true, // 是否支持键盘
    url: 'data-source' // 设置大图片的url
  }
})

Vue.prototype.$getUserInfo = getUserInfo
Vue.prototype.$win = window
Vue.prototype.$doc = window.document
// // 线下的地址  慢慢迁移到httpConfig.js中
Vue.prototype.$resBasePath = process.env.VUE_APP_BasePath // 非视频，如果为视频，则为spath1
Vue.prototype.$resBaseVideo = process.env.VUE_APP_BaseVideo // 视频路径
Vue.prototype.$downLoad = process.env.VUE_APP_DownLoad // 下载路径
Vue.prototype.$baseUrl = process.env.VUE_APP_BaseUrl //  'http://192.168.6.111:6620/' // 新增加路径
Vue.prototype.$uploadUrl = process.env.VUE_APP_UploadUrl
Vue.prototype.$studentUrl = process.env.VUE_APP_StudentUrl
Vue.prototype.$loginStudentUrl = process.env.VUE_APP_Login_student_url
Vue.prototype.$loginServer = process.env.VUE_APP_LoginServer
Vue.prototype.$loginUrl = process.env.VUE_APP_Login_url
Vue.prototype.$previewUrl = process.env.VUE_APP_PreviewUrl
if (!Vue.prototype.$loginUrl || !Vue.prototype.$loginStudentUrl) {
  console.warn(
    '[env] VUE_APP_Login_url 或 VUE_APP_Login_student_url 未注入，请检查当前构建 mode 对应的 .env 文件（例如 build:dev 使用 .env.dev111）。'
  )
}
Vue.prototype.$userINfoUploadUrl = process.env.VUE_APP_UserINfoUploadUrl
Vue.prototype.$userINfoBasePath = process.env.VUE_APP_UserINfoBasePath
Vue.prototype.$httpConfig = config
Vue.prototype.$http = http
Vue.prototype.$loginHttp = loginHttp
// 线上的地址 https://file.e-snails.com/spath/shandong/book/
// Vue.prototype.$resBasePath = 'https://file.e-snails.com/upload/res/path' // 非视频，如果为视频，则为spath1
// Vue.prototype.$resBaseVideo = 'https://file.e-snails.com/upload/res/getVideoPathByFile/' // 视频路径
// Vue.prototype.$downLoad = 'https://file.e-snails.com/upload/res/downLoad' // 下载路径
// Vue.prototype.$baseUrl = 'https://server.e-snails.com/' // 新增加路径
// Vue.prototype.$uploadUrl = 'https://file.e-snails.com/upload/res/uploadCustom'
// Vue.prototype.$studentUrl = 'https://www.e-snails.com/page/qt/stu/index.html'
// Vue.prototype.$loginServer = 'https://auth.greatwallchinese.com/'
// Vue.prototype.$userINfoUploadUrl = 'https://file.greatwallchinese.com/upload/res/uploadCustom/'
// Vue.prototype.$userINfoBasePath = 'https://file.greatwallchinese.com/upload/res/path/'
new Vue({
  render: (h) => h(App),
  router,
  store
}).$mount('#app')
